import React from 'react';
import './style.css';
import citrusLeaf from '../../assets/citrus-leaf.png';
import { Navigate, useNavigate } from 'react-router-dom';
import * as ics from 'ics';
import { writeFileSync } from 'fs';

export class Date extends React.Component {
    state = { checkin: null };
    // goToCheckin() {
    //     console.log('Hello');
    //     return <Navigate to={'/checkin'} />;
    // }

    goToCheckin() {
        try {
            this.setState({ checkin: true });
        } catch (error) {
            this.setState({ checkin: false });
        }
    }

    async createCalendarEvent() {
        const event: ics.EventAttributes = {
            start: [2024, 4, 13, 12, 30],
            duration: { hours: 15, minutes: 30 },
            title: 'Hochzeit von Jenni & Patrick',
            // description: 'Annual 10-kilometer run in Boulder, Colorado',
            location: 'Kirchsteige 14, 70329 Stuttgart',
            url: 'https://www.wir-heiraten.wiedicke.com/',
            // geo: { lat: 48.768036, lon: 9.2684 },
            // categories: ['10k races', 'Memorial Day Weekend', 'Boulder CO'],
            status: 'CONFIRMED',
            busyStatus: 'BUSY',
            organizer: {
                name: 'Patrick Wiedicke',
                email: 'wiedicke.patrick@gmail.com'
                // sentBy: 'wiedicke.patrick@gmail.com'
            },
            alarms: [
                {
                    action: 'audio',
                    description: 'Hochzeit von Jenni & Patrick',
                    repeat: 2,
                    // trigger: {
                    //     weeks: 1,
                    //     before: true
                    // },
                    trigger: {
                        weeks: 1,
                        before: true
                    },
                    attachType: 'VALUE=URI',
                    attach: 'Glass',
                    summary: 'T-5 Erinnerung'
                },
                {
                    action: 'audio',
                    description: 'Hochzeit von Jenni & Patrick',
                    repeat: 2,
                    // trigger: {
                    //     weeks: 1,
                    //     before: true
                    // },
                    trigger: {
                        days: 3,
                        before: true
                    },
                    attachType: 'VALUE=URI',
                    attach: 'Glass',
                    summary: 'T-5 Erinnerung'
                }
            ]
            // attendees: [
            //     {
            //         name: 'Adam Gibbons',
            //         email: 'adam@example.com',
            //         rsvp: true,
            //         partstat: 'ACCEPTED',
            //         role: 'REQ-PARTICIPANT'
            //     },
            //     {
            //         name: 'Brittany Seaton',
            //         email: 'brittany@example2.org',
            //         dir: 'https://linkedin.com/in/brittanyseaton',
            //         role: 'OPT-PARTICIPANT'
            //     }
            // ]
        };

        const filename = 'Hochzeitstermin_Jenni_Patrick.ics';
        const file: Blob = await new Promise((resolve, reject) => {
            ics.createEvent(event, (error, value) => {
                if (error) {
                    reject(error);
                }

                resolve(new File([value], filename, { type: 'text/calendar' }));
            });
        });

        const url = URL.createObjectURL(file);

        const anchor = document.createElement('a');
        anchor.href = url;
        anchor.download = filename;

        document.body.appendChild(anchor);
        anchor.click();
        document.body.removeChild(anchor);

        URL.revokeObjectURL(url);
    }

    render() {
        return (
            <div id="date-screen">
                {/* <div className="std-container">
                    <div className="std-content-container">
                        <div className="std-divider-container" style={{ justifyContent: 'end' }}>
                            <div className="std-divider" />
                        </div>
                        <div className="std-text-container">
                            <div className="std-text">SAVE THE DATE </div>
                        </div>

                        <div className="std-divider-container">
                            <div className="std-divider" />
                        </div>
                    </div>
                </div> */}
                <div className="date-container">
                    <div className="date-date-container">
                        <div className="date-text">13.04.2024</div>
                    </div>
                    <div className="date-time-container">
                        <div className="time-text">um 12:30 Uhr</div>
                    </div>
                </div>
                <div className="location-container">
                    <div className="location-text-container">
                        <div className="location-text">
                            in der Petruskirche,
                            <br />
                            Stuttgart-Obertürkheim
                        </div>
                    </div>
                </div>
                <div className="citrus-leaf-container">
                    <div className="citrus-leaf-left-container">
                        <img src={citrusLeaf} className="citrus-leaf-left" alt="Citrus Leaf" />
                    </div>
                    <div className="citrus-leaf-right-container">
                        <img src={citrusLeaf} className="citrus-leaf-right" alt="Citrus Leaf" />
                    </div>
                </div>
                <div className="accept-container">
                    <div className="calendar-container">
                        <button className="calender-entry-button" onClick={() => this.createCalendarEvent()}>
                            AB IN DEN KALENDER!
                        </button>
                    </div>

                    <div className="accept-button-container">
                        <button className="accept-button" onClick={() => this.goToCheckin()}>
                            ICH SAG DIREKT ZU! :)
                        </button>
                        {this.state.checkin && <Navigate to={'/checkin'}></Navigate>}
                    </div>
                </div>
            </div>
        );
    }
}
